module.exports = __webpack_public_path__ + "static/media/icon-search.fd466660.svg";